import * as fromCorrespondences from '../actions/correspondences.actions';
import { CorrespondenceInterface } from '@app/core/interfaces/correspondence.interface';

/**
 *  ids equals correspondentie_volgnummer
 */
export interface State {
    ids: string[];
    entities: { [id: string]: CorrespondenceInterface[] };
    loading: boolean;
    loaded: { [id: string]: boolean };
    errors: any[];
}

const initialState: State = {
    ids: [],
    entities: {},
    loading: false,
    loaded: {},
    errors: []
};

/**
 *  Object.assign(target, ...sources);
 *
 *  Properties in the target object will be overwritten by properties in the sources if they have the same key.
 *  Later sources' properties will similarly overwrite earlier ones.
 *
 *  Object.assign({}, currentEntities, newEntities);
 */

export function reducer(state = initialState, action: fromCorrespondences.Actions): State {

    switch (action.type) {
        case fromCorrespondences.LOAD: {
            return {
                ...state,
                loading: true
            };
        }

        case fromCorrespondences.LOAD_SUCCESS: {
            // New entities
            const dossier_volgnummer = action.payload.dossier_volgnummer;
            const correspondences = action.payload.correspondences;

            if (!correspondences) {
                return {
                    ...state,
                    loading: false
                };
            }

            // Create new ids
            const ids = state.ids.filter((id) => id !== dossier_volgnummer);

            // Loaded true
            const newLoadedState = { [action.payload.dossier_volgnummer]: true };

            // Return new state
            return {
                ...state,
                ids: [...ids, dossier_volgnummer],
                entities: Object.assign({}, state.entities, {
                    [dossier_volgnummer]: correspondences
                }),
                loading: false,
                loaded: Object.assign({},
                    state.loaded,
                    newLoadedState
                )
            };
        }

        case fromCorrespondences.LOAD_ERROR: {
            const dossier_volgnummer = action.payload.dossier_volgnummer;
            const newLoadedState = { [dossier_volgnummer]: true };
            const errors = (action.payload.errors) ? action.payload.errors : [];

            return {
                ...state,
                loading: false,
                entities: Object.assign({}, state.entities, {
                    [dossier_volgnummer]: []
                }),
                loaded: Object.assign({},
                    state.loaded,
                    newLoadedState
                ),
                errors: errors
            };
        }

        default: {
            return state;
        }
    }
}

export const getIds = (state: State) => state.ids;
export const getEntities = (state: State) => state.entities;
export const getLoaded = (state: State) => state.loaded;
